"use strict";exports.__esModule=true;exports.default=void 0;var _index=require("../../../lib/index.js");var _default=function _default(attr){var size=attr.patternSize+attr.patternDensity,color=(0,_index.hashify)(attr.color),hexColor=_index.validhexcolor.test(color)?color:(0,_index.rgbaToHex)(attr.color);return[{tagName:"rect",height:size,width:size,fill:attr.patternBgColor,opacity:attr.alpha/100},{tagName:"circle",cx:size/2,cy:size/2,r:attr.patternSize/2,stroke:hexColor,fill:hexColor,opacity:attr.patternAlpha/100}]};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/core/src/_internal/redraphael/pattern/circle.js
// module id = kGL8
// module chunks = 5